import { observer } from "mobx-react"
import { GeneralIcon } from "modules/common/components/planr/icon/Generalcon"
import internalFunc from "modules/main/functionalities"
import { useMst } from "modules/root/models/hooks"
import { can } from "modules/session/auth/access"
import React, { useEffect, useState } from "react"
import styles from "./Feedback.module.scss"
import { FeedbackDialog } from "./FeedbackDialog"

/** Документация по работе в системе */
const DOCS_URL = "https://docs.rostpro.tech/"

/** Бейдж при закрытом чате не срочный, а лимит чтений versionControl общий на всю компанию */
const UNREAD_POLL_INTERVAL = 60 * 1000
/** Открытый чат обновляем чаще: ответ разработчика ждут прямо сейчас */
const OPEN_POLL_INTERVAL = 30 * 1000

/** Иконки шапки: «?» со ссылкой на инструкцию и «Обратная связь» с бейджем непрочитанных ответов */
export const FeedbackButton = observer(() => {
  const { session, feedback } = useMst()
  const [open, setOpen] = useState(false)

  // обратная связь только для сотрудников
  const employee = can(internalFunc.INTERNAL_USER_ACCESS, session.access)

  useEffect(() => {
    if (!employee) {
      return
    }

    feedback.reset()
    feedback.loadStatus().then(() => feedback.loadUnread())
  }, [employee, session.userId, feedback])

  useEffect(() => {
    if (!employee || !feedback.enabled) {
      return
    }

    const timer = setInterval(() => {
      // в фоновой вкладке не опрашиваем: лимиты versionControl общие на всю компанию
      if (document.hidden) {
        return
      }

      if (open) {
        feedback.refresh()
      } else {
        feedback.loadUnread()
      }
    }, open ? OPEN_POLL_INTERVAL : UNREAD_POLL_INTERVAL)

    return () => clearInterval(timer)
  }, [employee, feedback, feedback.enabled, open])

  const feedbackVisible = employee && feedback.enabled

  return (
    <>
      <span className={styles.headerButtons}>
        <a
          className={`${styles.headerIcon} ${styles.headerHelp}`}
          href={DOCS_URL}
          target="_blank"
          rel="noopener noreferrer"
          title="Инструкция"
          aria-label="Инструкция"
        >
          <GeneralIcon type="general-question" size={18} />
        </a>

        {feedbackVisible && (
          <span className={styles.headerButton}>
<button
              type="button"
              className={styles.headerIcon}
              title="Обратная связь"
              aria-label="Обратная связь"
              onClick={() => setOpen(true)}
            >
              <GeneralIcon type="general-mail" size={18} />
            </button>
            {feedback.unread > 0 && (
              <span className={styles.headerBadge}>{feedback.unread > 99 ? "99+" : feedback.unread}</span>
            )}
          </span>
        )}
      </span>

      {open && (
        <FeedbackDialog
          store={feedback}
          userId={session.userId}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  )
})
